import React from "react";
import { Building, ThumbsUp, Award, CheckCircle } from "lucide-react"; // Add CheckCircle icon
import ChimneymainImg from '../../img/about-chimney-img.png';

const HomeAboutUs = () => {
    return (
        <section className="hob-aboutus-section">
            <div className="hob-aboutus-container">
                <div className="hob-aboutus-left">
                    <h2 className="hob-aboutus-heading">About Us</h2>
                    <p className="hob-aboutus-text">
                        Royal Ambulance provides 24×7 emergency ambulance services in Mumbai with fast response, advanced medical care, and trained paramedics. Our fleet includes ICU ambulances, cardiac ambulances, and road ambulances equipped with life-saving equipment. We specialize in emergency patient transfers, dead body freezer box hire, and outstation ambulance services across Maharashtra.
                    </p>

                    {/* Added unordered list with icons */}
                    <ul className="hob-aboutus-list">
                        <li><CheckCircle size={20} /> 20+ Years Experience</li>
                        <li><CheckCircle size={20} /> Growing Success</li>
                        <li><CheckCircle size={20} /> Best Service</li>
                        <li><CheckCircle size={20} /> Trusted by People</li>
                    </ul>
                </div>

                <div className="hob-aboutus-right">
                    <div className="hob-aboutus-image-wrapper">
                        <img
                            src={ChimneymainImg}
                            alt="Our Team"
                            className="hob-aboutus-image"
                        />

                        <div className="hob-aboutus-float hob-aboutus-top-right">
                            <div className="hob-aboutus-flex">
                                <Building size={18} />
                                <span>Since 2008</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Over 10 years of premium repair services.
                            </p>
                        </div>

                        <div className="hob-aboutus-float hob-aboutus-bottom-right">
                            <div className="hob-aboutus-flex">
                                <ThumbsUp size={18} />
                                <span>10K+ Happy Clients</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Trusted by thousands of satisfied clients.
                            </p>
                        </div>

                        <div className="hob-aboutus-float hob-aboutus-center-float">
                            <div className="hob-aboutus-flex">
                                <Award size={18} />
                                <span>Top-rated Repairs</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Industry leaders in appliance repair.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeAboutUs;
